import { FC } from 'react'

import DialogWindow from '@/components/DialogWindow'

import Cancel from '@/assets/icons/cancel-3.svg'
import Trash from '@/assets/icons/trash.svg'

interface IDeleteHighlightFoldersDialog {
	open: boolean
	onClose: () => void
	onDelete: () => void
}

const DeleteHighlightFoldersDialog: FC<IDeleteHighlightFoldersDialog> = ({
	open,
	onClose,
	onDelete
}) => {
	return (
		<DialogWindow
			handleClick={onDelete}
			open={open}
			onClose={onClose}
			titleText='Delete highlight folders?'
			body='Are you sure you want to delete these highlight groups? You cannot undo this action.'
			bodyClassname='text-left'
			noButtonText={
				<>
					<Cancel className='w-3 h-3' />
					<span>Cancel</span>
				</>
			}
			yesButtonText={
				<>
					<Trash />
					<span>Yes, delete folders</span>
				</>
			}
			noButtonClassname='!text-[16px] hover:bg-neutral-200'
			noButtonClassnameText='flex items-center gap-3'
			yesButtonClassname='bg-neutral-900 hover:bg-neutral-700'
			yesButtonClassnameText='flex items-center gap-3'
		/>
	)
}

export default DeleteHighlightFoldersDialog
